import { Text } from '@ekhodealer/ekho-common/rev';

import type { ReactNode } from 'react';

import './NavigationGrid.scss';

interface NavigationGridProps {
	/** Navigation box items to render in the grid. */
	children: ReactNode;
	/** Optional section heading displayed above the grid. */
	title?: string;
}

/**
 * Grid layout for NavigationBox items, with an optional section title.
 * Auto-fills columns between 340–387px wide.
 */
export function NavigationGrid({ children, title }: NavigationGridProps): ReactNode {
	return (
		<div data-component='navigation-grid'>
			{title && (
				<Text size='body' weight='bold'>
					{title}
				</Text>
			)}
			<div className='navigation-grid-items'>{children}</div>
		</div>
	);
}
